import React from "react"
import { graphql } from "gatsby"
import ConditionalLayout from "../components/ConditionalLayout"
import { theme } from "@singita/components"
import FullPageGallery from "../components/FullPageGallery"
import HelmetWrapper from "gatsby-singita-theme/src/components/Helmet"
import { useSeo } from "gatsby-singita-theme/src/hooks"
import { LODGE_DATA_MAP_SUBPAGES } from "../common/constants"
import { TEMPLATE_TYPES } from "gatsby-singita-theme/src/common/constants"
import { NavbarContext } from "gatsby-singita-theme/src/context/NavbarContext"

const GalleryTemplate = props => {
  const {
    data: { lodge },
    location: { state },
  } = props
  const { isModal } = state || {}
  const seoData = useSeo(lodge, LODGE_DATA_MAP_SUBPAGES, TEMPLATE_TYPES.GALLERY)
  seoData.title = `${seoData.sdTitle} | Photo & Video Gallery | Singita`
  seoData.description = `View Singita's life changing game drives, bush walks and holistic wellness treatments to soothe the soul at ${seoData.sdTitle}`
  const [filterOffset, setFilterOffset] = React.useState(0)
  const { navbarHeight, setNavbarStyles } = React.useContext(NavbarContext)

  React.useEffect(() => {
    setNavbarStyles({ bg: theme.colors.bgLighter })
  }, [])

  React.useEffect(() => {
    if (isModal) {
      const elem = document.getElementById("large-modal-header")
      if (elem) {
        const dims = elem.getBoundingClientRect()
        setFilterOffset(dims.height)
      }
    } else {
      setFilterOffset(navbarHeight)
    }
  }, [isModal, navbarHeight])

  return (
    <>
      <HelmetWrapper {...seoData} />

      <ConditionalLayout
        modalSize="large"
        modalTitle={lodge.fullTitle}
        bg={theme.colors.brandBeige}
        pageContext={props.pageContext}
      >
        {_ => (
          <FullPageGallery
            title={`${lodge.fullTitle} Gallery`}
            galleries={lodge.galleries}
            isModal={isModal}
            filterOffset={filterOffset}
          />
        )}
      </ConditionalLayout>
    </>
  )
}

export default GalleryTemplate

export const LODGE_GALLERY_QUERY = graphql`
  query lodgeGalleryQuery($slug: String!, $locale: String) {
    lodge: contentfulLodge(slug: { eq: $slug }, node_locale: { eq: $locale }) {
      id
      fullTitle
      structuredData {
        headline
        image {
          # fluid(maxWidth: 800, quality: 95) {
          #   ...GatsbyContentfulFluid_withWebp_noBase64
          # }
          gatsbyImageData(
            layout: CONSTRAINED
            placeholder: NONE
            formats: [AUTO, WEBP]
            quality: 95
            width: 800
          )
        }
      }
      shortDescription {
        shortDescription
      }
      region {
        headline
        country
      }
      image {
        # fluid(maxWidth: 800, quality: 95) {
        #   ...GatsbyContentfulFluid_withWebp_noBase64
        # }
        gatsbyImageData(
          layout: CONSTRAINED
          placeholder: NONE
          formats: [AUTO, WEBP]
          quality: 95
          width: 800
        )
      }
      galleries {
        __typename
        ...ContentContentAssetFields
      }
    }
  }
`
